import axiosInstance from "@/api/axiosInstance";
import type {
  CreateMembershipSkuFormData,
  MembershipSku,
  UpdateMembershipSkuFormData,
} from "../schemas/membershipSkuSchema";

const API_BASE_URL = "/api/private/membership-skus";

/**
 * Fetch all membership SKUs
 * @param tenant - Optional tenant ID to filter SKUs
 */
export const fetchMembershipSkus = async (
  tenant?: string,
): Promise<MembershipSku[]> => {
  const params = tenant ? { tenant } : {};
  const response = await axiosInstance.get<{ data: MembershipSku[] }>(
    API_BASE_URL,
    { params },
  );
  // The API returns {data: [...]} so we need to extract the data property
  return response.data.data || [];
};

/**
 * Fetch a single membership SKU by UUID
 */
export const fetchMembershipSkuByUuid = async (
  uuid: string,
): Promise<MembershipSku> => {
  const response = await axiosInstance.get<MembershipSku>(
    `${API_BASE_URL}/${uuid}`,
  );
  return response.data;
};

/**
 * Create a new membership SKU
 */
export const createMembershipSku = async (
  data: CreateMembershipSkuFormData,
): Promise<MembershipSku> => {
  const response = await axiosInstance.post<MembershipSku>(API_BASE_URL, data);
  return response.data;
};

/**
 * Update an existing membership SKU
 */
export const updateMembershipSku = async (
  uuid: string,
  data: UpdateMembershipSkuFormData,
): Promise<MembershipSku> => {
  const response = await axiosInstance.put<MembershipSku>(
    `${API_BASE_URL}/${uuid}`,
    data,
  );
  return response.data;
};

/**
 * Delete (soft delete) a membership SKU
 */
export const deleteMembershipSku = async (uuid: string): Promise<void> => {
  await axiosInstance.delete(`${API_BASE_URL}/${uuid}`);
};
